module.exports = __webpack_public_path__ + "img/reset-password-v2-dark.13bbc9e7.svg";